{
  "aboutFarmJoinCodes": "Informazioni sui codici di adesione alla fattoria",
  "back": "Indietro",
  "codeExpired": "Codice scaduto",
  "codeExpiredErrorMessage": "Il tuo codice di adesione alla fattoria è scaduto. Per consentire a nuovi utenti di unirsi al tuo account della fattoria, devi creare un nuovo codice.",
  "codeExpiresWithColon": "Il codice scade:",
  "codeNotCreated": "Codice non creato",
  "codeNotCreatedErrorMessage": "Devi creare un nuovo codice di adesione alla farm per consentire agli utenti di unirsi alla tua farm.",
  "codeWithColon": "Codice:",
  "copyCode": "Copia",
  "farmJoinCode": "Codice di adesione alla fattoria",
  "farmJoinCodeHelpSummary": "I Farm Join Codes sono codici a 6 cifre generati casualmente che consentono ai nuovi utenti di unirsi a un account farm. Quando l'utente si unisce, inizierà con le autorizzazioni specificate nella farm.\n\nI Farm Join Codes scadono dopo un certo periodo di tempo. Se crei un codice e il codice scade, dovrai crearne uno nuovo se vuoi che i nuovi utenti possano unirsi alla tua farm.",
  "farmJoinCodeNotCreatedMessage": "Devi creare un nuovo codice di adesione alla farm per consentire agli utenti di unirsi alla tua farm.",
  "farmJoinCodeShareMessageWithActiveFarmNameAndCodeString": "Usa questo codice di join farm per unirti alla farm {{activeFarmName}}\n{{codeString}}",
  "farmJoinCodeShareTitleWithActiveFarmName": "[FarmHQ]: Codice di adesione per {{activeFarmName}}",
  "farmJoinCodeStatus": {
    "ACTIVE": "Attivo",
    "EXPIRED": "Scaduto",
    "NOT_CREATED": "Non creato"
  },
  "farmJoinCodeTitle": "Codice di adesione alla fattoria",
  "newCode": "Nuovo codice",
  "newFarmJoinCode": "Nuovo codice di adesione alla fattoria",
  "newFarmJoinCodeHelpSummary": "Quando un utente si unisce alla tua farm immettendo un Farm Join Code, gli vengono assegnate le autorizzazioni specificate al momento della creazione del codice. Le autorizzazioni di un utente possono essere modificate in seguito da un amministratore della farm.",
  "note": "Nota:",
  "shareCode": "Condividere",
  "somethingWentWrong": "Qualcosa è andato storto",
  "unableToCopyCode": "Impossibile copiare il codice",
  "yourCode": "Il tuo codice"
}
